import { GoabText } from '@abgov/angular-components';
import '@abgov/web-components';
import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';

/*
 * This component displays a feedback message with an icon, title, optional subtitle, and text lines.
 *
 * The icon type is a string which must come from the set displayed in the Type dropdown
 * in the Angular Components documentation (https://design.alberta.ca/components/v4.0.0+-angular/icon#tab-1).
 *
 * Custom HTML may be inserted into the component (there is an ng-content directive at the bottom of the template).
 */

export type IconType = 'lock-open' | 'search' | 'warning'; // add more types as needed, see the comment above

@Component({
  selector: 'app-feedback-message',
  imports: [CommonModule, GoabText],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './feedback-message.component.html',
  styleUrl: './feedback-message.component.scss',
})
export class FeedbackMessageComponent {
  iconType = input.required<IconType>();
  title = input.required<string>();
  subtitle = input<string>('');
  textLines = input<string[]>([]);
}
